module.exports = __webpack_public_path__ + "images/faceymflogo.png";


//////////////////
// WEBPACK FOOTER
// ./assets/faceymflogo.png
// module id = 4
// module chunks = 0